import http from "@/settings/apiSettings";
import type { Branding } from "@/services/BrandingService";

// Backend = PreserveCaseNamingPolicy => JSON PascalCase. Convertim în ambele sensuri.
function toLocal(d: any): Branding {
  const feats = Array.isArray(d?.Features ?? d?.features) ? (d.Features ?? d.features) : [];
  return {
    slug: d?.Slug ?? d?.slug ?? "",
    color: d?.Color ?? d?.color,
    logoText: d?.LogoText ?? d?.logoText,
    logoUrl: d?.LogoUrl ?? d?.logoUrl,
    title: d?.Title ?? d?.title,
    subtitle: d?.Subtitle ?? d?.subtitle,
    active: (d?.Active ?? d?.active) ?? true,
    features: feats.map((f: any) => ({
      icon: f?.Icon ?? f?.icon ?? "",
      color: f?.Color ?? f?.color ?? "",
      title: f?.Title ?? f?.title ?? "",
      desc: f?.Desc ?? f?.desc ?? "",
    })),
  };
}

function toWire(b: Branding): any {
  return {
    Slug: b.slug,
    Color: b.color,
    LogoText: b.logoText,
    LogoUrl: b.logoUrl,
    Title: b.title,
    Subtitle: b.subtitle,
    Active: b.active ?? true,
    Features: (b.features || []).map((f) => ({
      Icon: f.icon, Color: f.color, Title: f.title, Desc: f.desc,
    })),
  };
}

/** Administrare branding login per client (SuperAdmin). Cheia = slug. */
class BrandingAdminService {
  async getAll(): Promise<Branding[]> {
    const r = await http.clientAuth.get("/Branding");
    return (r.data || []).map(toLocal);
  }

  async upsert(dto: Branding): Promise<Branding> {
    const r = await http.clientAuth.post("/Branding", toWire(dto));
    return toLocal(r.data);
  }

  remove(slug: string): Promise<any> {
    return http.clientAuth.delete(`/Branding/${slug}`);
  }
}

export default new BrandingAdminService();
